import React from 'react';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

const STEPS = [
  { label: 'Boas-vindas' },
  { label: 'Plataforma' },
  { label: 'Configuração' },
  { label: 'Confirmar' },
];

interface OnboardingStepperProps {
  currentStep: number; // 1-4
}

export const OnboardingStepper: React.FC<OnboardingStepperProps> = ({ currentStep }) => {
  const progress = ((currentStep - 1) / (STEPS.length - 1)) * 100;

  return (
    <div className="space-y-3">
      {/* Continuous progress bar */}
      <div className="relative h-1.5 rounded-full bg-muted overflow-hidden">
        <motion.div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{ background: 'var(--gradient-primary)' }}
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        />
      </div>

      {/* Step labels */}
      <nav aria-label="Etapas do onboarding" className="flex items-center justify-between">
        {STEPS.map((step, idx) => {
          const stepNum = idx + 1;
          const done = stepNum < currentStep;
          const active = stepNum === currentStep;
          return (
            <div key={stepNum} className="flex flex-col items-center gap-1.5">
              <motion.div
                className={cn(
                  'flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold transition-colors',
                  done && 'bg-primary text-primary-foreground',
                  active && 'bg-primary/15 text-primary ring-2 ring-primary/30',
                  !done && !active && 'bg-muted text-muted-foreground'
                )}
                animate={active ? { scale: [1, 1.1, 1] } : {}}
                transition={{ duration: 0.4 }}
              >
                {done ? <Check className="w-3.5 h-3.5" /> : stepNum}
              </motion.div>
              <span className={cn(
                'text-xs font-medium truncate max-w-[70px] text-center',
                active ? 'text-primary' : done ? 'text-foreground' : 'text-muted-foreground'
              )}>
                {step.label}
              </span>
            </div>
          );
        })}
      </nav>
    </div>
  );
};
